var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10671 7.24665C6.04004 7.23998 5.96004 7.23998 5.88671 7.24665C4.30004 7.19332 3.04004 5.89332 3.04004 4.29332C3.04004 2.65998 4.36004 1.33331 6.00004 1.33331C7.63337 1.33331 8.96004 2.65998 8.96004 4.29332C8.95337 5.89332 7.69337 7.19332 6.10671 7.24665Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.94 2.66669C12.2333 2.66669 13.2733 3.71335 13.2733 5.00002C13.2733 6.26002 12.2667 7.28669 11.0133 7.33335C10.96 7.32669 10.9 7.32669 10.84 7.33335",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77329 9.70669C1.15996 10.7867 1.15996 12.5467 2.77329 13.62C4.60663 14.8467 7.61329 14.8467 9.44663 13.62C11.06 12.54 11.06 10.78 9.44663 9.70669C7.61996 8.48669 4.61329 8.48669 2.77329 9.70669Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2267 13.3333C12.7067 13.2333 13.16 13.04 13.5334 12.7533C14.5734 11.9733 14.5734 10.6867 13.5334 9.90666C13.1667 9.62666 12.72 9.44002 12.2467 9.33331",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.b0dc62e27c9126a237af9bb619c315db.svg";
export { ForwardRef as ReactComponent };